<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";
    import ArrowIcon from "@components/icons/ArrowIcon.svelte";

    const dispatch = createEventDispatcher();

    const hanldePrev = () => dispatch("prev");
    const hanldeNext = () => dispatch("next");
</script>

<BaseButton
    class="gw-reviews-gallery-arrows__arrow gw-reviews-gallery-arrows__arrow--prev"
    on:click={hanldePrev}
>
    <Icon width="24" height="24" viewBox="0 0 24 24">
        <ArrowIcon />
    </Icon>
</BaseButton>

<BaseButton
    class="gw-reviews-gallery-arrows__arrow gw-reviews-gallery-arrows__arrow--next"
    on:click={hanldeNext}
>
    <Icon width="24" height="24" viewBox="0 0 24 24">
        <ArrowIcon />
    </Icon>
</BaseButton>

<style lang="postcss">
    .gw-btn.gw-reviews-gallery-arrows {
        :global(&__arrow) {
            width: 50px;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 50%;
            background-color: #fff;
            border-radius: 50%;
            color: #3c3c3c;

            @media screen and (max-width: 600px) {
                position: fixed;
                top: 300px;
                background-color: rgba(0, 0, 0, 0.4);
                color: #fff;
                width: 40px;
                height: 40px;
            }
        }

        :global(&__arrow--prev) {
            transform: translateY(-50%) rotate(180deg);
            left: -100px;
            box-shadow: 0px -5px 10px 0px rgba(0, 0, 0, 0.5);

            &:active {
                transform: translateY(-50%) rotate(180deg) scale(0.95);
            }

            @media screen and (max-width: 1080px) {
                left: -80px;
            }

            @media screen and (max-width: 600px) {
                left: 0;
                box-shadow: none;
                border-radius: 2px 0 0 2px;
            }
        }

        :global(&__arrow--next) {
            transform: translateY(-50%);
            right: -100px;
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5);

            &:active {
                transform: translateY(-50%) scale(0.95);
            }

            @media screen and (max-width: 1080px) {
                right: -80px;
            }

            @media screen and (max-width: 600px) {
                right: 0;
                box-shadow: none;
                border-radius: 2px 0 0 2px;
            }
        }
    }
</style>
